'use client'

import React, { useEffect, useState, useId } from 'react'
import mermaid from 'mermaid'

// Initialize with a dark theme to match your UI
mermaid.initialize({
  startOnLoad: false,
  theme: 'dark',
  securityLevel: 'strict',
  fontFamily: 'monospace',
})

export default function MermaidDiagram({ chart }: { chart: string }) {
  const [svg, setSvg] = useState<string>('')
  // Generate a unique, DOM-safe ID for each diagram instance
  const id = `mermaid-${useId().replace(/:/g, '')}`

  useEffect(() => {
    let isMounted = true

    const renderChart = async () => {
      try {
        // Mermaid will parse the syntax and return the SVG string
        const { svg: renderedSvg } = await mermaid.render(id, chart)
        if (isMounted) setSvg(renderedSvg)
      } catch (error) {
        console.error('Mermaid rendering failed:', error)
        // Fallback for invalid syntax
        if (isMounted) {
          setSvg(`<div class="text-rose-400 text-xs p-4 border border-rose-500/30 bg-rose-500/10 rounded">Syntax Error in Diagram</div>`)
        }
      }
    }

    if (chart) {
      renderChart()
    }

    return () => {
      isMounted = false
    }
  }, [chart, id])

  if (!svg) {
    return <div className="w-full h-32 bg-slate-900/50 animate-pulse rounded-xl border border-slate-800 my-4" />
  }

  return (
    <div 
      className="flex justify-center items-center my-6 p-6 bg-slate-900/40 border border-slate-800/80 rounded-xl overflow-x-auto shadow-inner"
      dangerouslySetInnerHTML={{ __html: svg }} 
    />
  )
}